import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fRef } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { MenulikeItemPresentation } from '../MenulikeItem/MenulikeItemPresentation.js';
import { hostClass } from './ActionFlyoutItem.styles.js';

var ActionFlyoutItemPresentation = fRef(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    actionRef = props.actionRef,
    onMouseHoverChange = props.onMouseHoverChange,
    disabled = props.disabled,
    href = props.href,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    name = props.name,
    otherProps = __rest(props, ["id", "children", "className", "noMargin", "isStencilHost", "actionRef", "onMouseHoverChange", "disabled", "href", "hasMouseHover", "hasKeyboardFocus", "name"]);
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
    id: id,
    ref: actionRef,
    onMouseHoverChange: onMouseHoverChange,
    hasTabIndex: false,
    disabled: disabled,
    href: disabled ? undefined : href,
    name: name,
    role: "menuitem",
    fullWidth: true
  }, otherProps), /*#__PURE__*/React.createElement(MenulikeItemPresentation, {
    hasTabIndex: false,
    label: "",
    highlight: hasMouseHover || hasKeyboardFocus,
    disabled: disabled
  }, children)));
});
ActionFlyoutItemPresentation.displayName = "ActionFlyoutItemPresentation";

export { ActionFlyoutItemPresentation };
